import ApiService from '../../../components/api_services/apiService.jsx';

import { setRowsT, setMaxPagesT, toggleCheckedItemT, setPageT, setSortListEndpointT } from '../../../store/opinionsTTabSlice';

import store from '../../../store/store.js';


export const changeSortingListConfiguration = async( sort ) => {
  ApiService.setSortListEndpoint(sort);
}


export const fetchOpinionsT = async (sortBy, sortDirection, keyword, currentPage, dispatch, checkedItems) => {
  try {
    const checkedSortBy = sortBy === null || sortDirection === null ? null : sortBy;
    const checkedSortDirection = sortBy === null || sortDirection === null ? null : sortDirection;
    const response = await ApiService.getOpinionsT(checkedSortBy, checkedSortDirection, keyword, currentPage - 1);
    console.log('Odpowiedź z API:', response);

    dispatch(setMaxPagesT(response.totalPages)); // Ustawienie maksymalnej liczby stron na podstawie danych z API
    
    // Przechowuj tylko surowe dane w Redux, bez komponentów React
    const mappedRows = response.content.map((data) => ({
      id: data.id,
      checked: checkedItems.includes(data.id),
      addedOn: data.addedOn ? `${data.addedOn.split('T')[0]} ${data.addedOn.split('T')[1].substring(0, 5)}` : '',
      trainingName: data.trainingName,
      userName: data.userName,
      sportName: data.sportName,
      scoreLevel: data.scoreLevel,
      senderName: data.senderName
    }));
    
    dispatch(setRowsT(mappedRows)); // Ustawienie wierszy w stanie
    let currentPageState = store.getState().opinionsT.currentPage;
    keyword && currentPageState !== 1 && dispatch(setPageT(1)); // Resetowanie strony przy wyszukiwaniu
  } catch (error) {
    console.error('Błąd podczas pobierania danych:', error);
  }
};